import { LayoutGeometryHelper as G } from './layout-geometry-helper';
import type {
  DraftLine,
  PlacedNode,
  Rect,
  ReferenceChip,
  ShareLabel,
  UnlinkedTray,
} from './structure-layout.types';

class LayoutBoundsHelper {
  static compute(parts: {
    nodes: ReadonlyArray<PlacedNode>;
    lines: ReadonlyArray<DraftLine>;
    labels: ReadonlyArray<ShareLabel>;
    chips: ReadonlyArray<ReferenceChip>;
    tray: UnlinkedTray | null;
  }): Rect {
    return G.unionRects([
      ...parts.nodes,
      ...parts.labels,
      ...parts.chips,
      ...parts.lines.map((line) => G.pointsToRect(line.points)),
      ...(parts.tray ? [parts.tray.heading] : []),
    ]);
  }
}

export { LayoutBoundsHelper };
